// extracted by mini-css-extract-plugin
module.exports = {"InfPhoneCheckModal":"InfPhoneCheckModal--sP5za"};